<script>
import FavoriteTool from '../lib/favorite-tool.vue'

export default {
    components: {FavoriteTool},
    props: {
        favKey: {type: String, required: true},
        favMode: {type: Boolean, required: true},
        filter: {type: Object, required: true},
    },

    computed: {
        favActive() {
            return Object.prototype.hasOwnProperty.call(this.filter, "favorites")
        }
    },

    data() {
        return {
            search: this.filter.search,
            togglerCollapsed: true,
        }
    },

    methods: {
        onSearchInput() {
            if (this.search === '') this.$emit('delete-search')
        }
    },
}
</script>

<template>
<nav class="c-talk-navbar navbar navbar-expand-lg justify-content-between bg-light px-3">

  <favorite-tool v-if="!favMode" :active="favActive" @click="$emit('toggle-favorites', !favActive)" />

  <div class="ms-auto">
    <form class="form-inline">
        <div class="d-flex flex-nowrap">
        <input class="form-control me-2" type="search" placeholder="Quick Search" v-model="search"
         v-on:keyup.enter="$emit('search', search)" @input="onSearchInput()">
        <button class="btn btn-secondary" @click.prevent="$emit('search', search)">
            <span class="fa fa-search"></span>
        </button>
        </div>
    </form>
  </div>
</nav>
</template>